export default "__VITE_ASSET__BXKAS$K0__"